const c = {
  name: "AppleLogoOutline",
  dimensions: { width: 33, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 33.2 40" style="enable-background:new 0 0 33.2 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.1,10c-0.1,0-0.3,0-0.4,0L15.9,10l-0.1-0.8c-0.3-2.4,0.9-4.8,2.1-6.2c1.5-1.6,3.9-2.9,6-3l0.9,0l0.1,0.9
			c0.2,2.1-0.5,4.4-2.1,6.3C21.4,9,19.2,10,17.1,10L17.1,10z M22.9,2.2c-1.3,0.3-2.7,1.1-3.5,2.1c-0.8,0.8-1.6,2.2-1.7,3.7
			c1.4-0.2,2.8-1.1,3.6-2.1C22.2,4.8,22.8,3.5,22.9,2.2z"/>
		<path class="st0" d="M4.2,34.9c1.4,2,3.6,5.1,6.7,5.1l0,0h0.2c1.3,0,2.2-0.4,3-0.8l0,0l0,0c0.9-0.4,1.7-0.7,3.1-0.7
			c1.3,0,2.1,0.3,3,0.7c0,0,0,0,0.1,0c0.9,0.4,1.8,0.8,3.3,0.7c3.2-0.1,5.1-2.8,6.6-5l0,0c2-2.8,2.8-5.6,2.8-5.6l0.2-0.9l-0.9-0.3
			c-0.2-0.1-4.4-1.7-4.5-6.5c0-3.3,2.2-5.3,3.6-6.1l0.9-0.7l-0.6-0.8c-2.5-3.5-6.2-4-7.7-4.1c-2-0.2-3.9,0.5-5.4,1.1
			c0,0-0.1,0-0.1,0c-0.7,0.3-1.4,0.5-1.8,0.5c-0.4,0-1.1-0.3-1.9-0.5c0,0-0.1,0-0.1,0c-1.2-0.5-2.7-1-4.3-1c-3.6,0.1-6.9,2-8.7,5.1
			C-1.7,21,0.4,29.7,4.2,34.9z M10.5,12.1L10.5,12.1L10.5,12.1c1.2,0,2.4,0.4,3.5,0.8c0,0,0,0,0.1,0l0,0c1,0.4,1.9,0.7,2.7,0.7
			c0.8,0,1.6-0.3,2.6-0.7c1.4-0.5,3-1.1,4.6-1c1.1,0.1,3.6,0.4,5.6,2.5c-1.5,1.2-3.7,3.6-3.6,7.2c0,4.8,3.2,7.1,4.9,8
			c-0.3,0.9-1,2.5-2.2,4.1c-1.6,2.3-3,4.1-5,4.1c-1,0-1.7-0.3-2.5-0.6c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c-0.9-0.4-1.9-0.8-3.6-0.8
			c-1.7,0-2.9,0.5-3.9,0.9l0,0C12.6,37.7,11.9,38,11,38c-1.9,0.1-3.5-2-5.2-4.2c-2.9-4-5.6-12.2-2.4-17.5
			C4.9,13.8,7.6,12.2,10.5,12.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as AppleLogoOutline
};
